import { Controller } from "@hotwired/stimulus"

// Registers the panel's service worker (public/panel-sw.js: push and
// notification clicks, no offline cache) once per page load. Sits on <body>
// of the panel layout, so every panel page keeps the registration current;
// push_controller.js on the Today page subscribes through it.
let registered = false

export default class extends Controller {
  static values = { url: { type: String, default: "/panel-sw.js" } }

  connect() {
    if (registered || !("serviceWorker" in navigator)) return
    registered = true
    navigator.serviceWorker.register(this.urlValue, { scope: "/" }).catch(error => {
      registered = false
      console.warn("Service worker registration failed:", error)
    })
  }
}
